import { Component, Host, h, Prop, Event, EventEmitter, Element, State, Method } from '@stencil/core';

@Component({
  tag: 'jump-card-ecommerce-showcase',
  styleUrl: 'jump-card-ecommerce-showcase.scss',
  shadow: true,
})
export class JumpCardEcommerceShowcase {

  @Element() JumpCardEcommerceShowcase: HTMLElement;
  jumpQuantityEl;

  /* ---------------------- @PROPERTIES ------------------------- */

  /** Indicates the threshold below which the discount will be hidden */
  @Prop() hideDiscountIfLessThreshold: number = undefined;

  /** Indicates the badge of the card*/
  @Prop() badge: string;

  /** Indicates the link of the card*/
  @Prop() link: string;

  /** Indicates the image's src of the card*/
  @Prop() img: string;

  /** Indicates the img's alt of the card*/
  @Prop() imgAlt: string;

  /** Indicates the title of the card*/
  @Prop() productName: string;

  /** Indicates the subtitle of the card*/
  @Prop() subtitle: string;

  /** Indicates the ID of the product, can be also a SKU*/
  @Prop() productId: string;

  /** Indicates the price of the card */
  @Prop() price: number;

  /** Indicates the sale price of the card */
  @Prop() salePrice: number;

  /** Indicates the currency of the card */
  @Prop() currency: string = '€';

  /** Indicates the variant of the button */
  @Prop() badgeColor: 'primary' | 'secondary' | 'neutral' | 'warning' | 'success' | 'danger' = 'secondary';

  /** Indicates if the product is outOfStock */
  @Prop({ mutable: true, reflect: true }) outOfStock: boolean = false;

  /** Indicates the outOfStockText of the product*/
  @Prop() outOfStockText: string;

  @Prop() availableText: string;
  
  /** Controlla il comportamento dell'object-fit delle immagini */
  @Prop() imageObjectFit: 'cover' | 'scale-down' | 'contain' | 'fill' | 'none' = 'cover';

  


  /* ---------------------- @STATE ------------------------- */

  @State() priceFormatted: string;

  @State() salePriceFormatted: string;

  /* ---------------------- @EVENTS ------------------------- */

  @Event({ eventName: 'jump-card-go-to-product-page' }) goToProductPage: EventEmitter;

  /**
   * Set the price of the product
   * @param price
   * @param salePrice
   */
  @Method()
  async setPrice(price: number, salePrice: number) {
    let shouldFormat = false;
    if (price && price > 0) {
      shouldFormat = true;
      this.price = price;
    }

    if (salePrice && salePrice > 0) {
      this.salePrice = salePrice;
    }

    if (shouldFormat) {
      this.formatPrices();
    }
  }

  /* ---------------------- @LIFECYCLE ------------------------- */

  componentDidLoad() {
    this.formatPrices();
  }

  /* ---------------------- @METHODS ------------------------- */

  goToProduct(){
    this.goToProductPage.emit({
      productId: this.productId,
      link: this.link,
    });
  }

  formatPrices() {
    let locale = document.documentElement.lang ?? 'it-IT';
    if (locale.length == 2) {
      locale = `${locale}-${locale.toUpperCase()}`;
    }

    // Format price with 2 decimal digits and in locale
    this.priceFormatted = this.price.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    this.salePriceFormatted = this.salePrice.toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  render() {
    const backgroundClass = 'hasBackground';
    const iconOnlyClass = '';

    const hasImageOnHover =  '';
    const miniCard = '';
    const verticalCardClass = 'is-vertical';
    const enableZoomClass = '';

    function calculateDiscount(price: number, salePrice: number): string {
      const discount = ((price - salePrice) / price) * 100;
      return discount.toFixed(0);
    };

    return (
      <Host style={{'--image-object-fit': this.imageObjectFit}}>

        <div
          class={`Media ${iconOnlyClass} ${backgroundClass} ${miniCard}`}
        >
          {this.badge ?
            <jump-badge class={`${backgroundClass} ${iconOnlyClass}`} variant={this.badgeColor} dimension="small"
                        label={this.badge}></jump-badge> : ''}
          
          {this.salePrice && (this.salePrice < this.price) && (this.hideDiscountIfLessThreshold === undefined || parseFloat(calculateDiscount(this.price, this.salePrice)) > this.hideDiscountIfLessThreshold) ?
            <div class="DiscountBadge">-{calculateDiscount(this.price, this.salePrice)}%</div> : null}

          <a href={this.link}>
            <figure class={`Images ${hasImageOnHover} ${enableZoomClass}`}>
              {this.img && <img class="Images__Front" src={this.img} alt={this.imgAlt}></img> }
             
            </figure>
          </a>
        </div>

        <div class={`Content ${backgroundClass} ${iconOnlyClass} ${miniCard} ${verticalCardClass}`}>
          <div class={`Body ${backgroundClass} ${iconOnlyClass} ${miniCard} ${verticalCardClass}`}>
            <div class="Body__Top">
              <div class="Info">
                <a href={this.link} class="Product">{this.productName}</a>
               {this.subtitle ? <div class="Subtitle" onClick={() => this.goToProduct()}>{this.subtitle}</div> : null}
              </div>

              {this.price ?
                <div class={`Price ${miniCard}`}>
                  <div class={`Price__Regular ${this.salePrice && this.salePrice < this.price ? 'sale' : ''}`}>
                    {this.currency}{this.priceFormatted}
                  </div>
                   
                  {this.salePrice && this.salePrice < this.price ?
                    <div class="Price__Sale">{this.currency}{this.salePriceFormatted}</div>
                    : null}
                </div>
                : null}
              
              {this.outOfStock ?
              <div class="OutOfStock">{this.outOfStockText ? this.outOfStockText : 'Esaurito'}</div> :  <div class="AvailableStock">{this.availableText ? this.availableText : 'Disponibile'}</div>}

            </div>
          </div>

       
        </div>
      </Host>
    );
  }

}